import { memo, useRef } from 'react'
// import WaveSurfer from 'wavesurfer.js'
import { IAudioItem } from 'types/audio'
import * as Styled from './styled'
// import { AUDIO_ITEM_COLORS } from '../consts'
// import { COLORS } from 'consts/colors'
import { useTimelineItemBodyRect } from 'hooks/timeline'

interface IAudioWaveProps {
  audioItem: IAudioItem
  isActive: boolean
  isDraft: boolean
}

const AudioWave = ({ audioItem }: IAudioWaveProps) => {
  // const { mediaPath, type } = audioItem
  const containerRef = useRef<HTMLDivElement>(null)
  // const waveSurferRef = useRef<WaveSurfer>(null)

  // const { waveColor } = AUDIO_ITEM_COLORS[type]

  const { bodyWidth: audioWaveWidth, bodyLeft: audioWaveLeft } =
    useTimelineItemBodyRect({
      trimStart: audioItem.mediaStart,
      originalDuration: audioItem.mediaDuration
    })

  // useEffect(() => {
  //   if (!containerRef.current) return
  //   waveSurferRef.current = WaveSurfer.create({
  //     url: `${mediaPath}`,
  //     container: containerRef.current,
  //     progressColor: waveColor,
  //     waveColor,
  //     barWidth: 1,
  //     barGap: 1,
  //     cursorWidth: 0,
  //     barRadius: 1,
  //     height: 28,
  //     interact: false
  //   })
  //   return () => {
  //     waveSurferRef.current?.destroy()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [mediaPath, containerRef])

  // change wave color when active
  // useEffect(() => {
  //   const color = isActive
  //     ? COLORS.white
  //     : isDraft
  //       ? COLORS.secondary
  //       : waveColor

  //   waveSurferRef.current?.setOptions({
  //     progressColor: color,
  //     waveColor: color
  //   })
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isActive, isDraft])

  const audioWaveStyle = {
    width: `${audioWaveWidth}px`,
    left: `${audioWaveLeft}px`
  }

  return <Styled.AudioWaveWrapper ref={containerRef} style={audioWaveStyle} />
}

export default memo(AudioWave)
